<template>
  <div
    :key="`setting-card-${loading ? 'loading' : item.settingOrganizationId}`"
    class="organizer-setting-card main__light_green rounded-lg pa-6"
    :class="{'loading': loading}"
    :data-qa="`setting-card-${loading ? 'loading' : item.settingOrganizationId}`"
    @click="showDetile = !showDetile">
    <div
      class="d-flex flex-nowrap pb-4">
      <div
        :key="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-caption`"
        class="organizer-setting-card__caption"
        :data-qa="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-caption`">
        <div
          :key="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-title`"
          class="first-row"
          :data-qa="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-title`">
          {{ loading ? '-' : (item.settingTitle || item.settingInfo.settingTitle) }}
        </div>
        <div
          :key="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-old-code`"
          class="second-row"
          :data-qa="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-old-code`">
          {{ loading ? '-' : item.settingOldCode || item.settingInfo.settingOldCode }}
        </div>
        <div
          :key="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-settingType`"
          class="second-row opacity-3"
          :data-qa="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-settingType`">
          {{ loading ? '-' : item.settingInfo.settingType }}
        </div>
      </div>
      <slot name="menu"/>
    </div>
    <div
      class="flex">
      <KeyValue
        :caption="$t('Common.Code')"
        class="width-15 pr-3">
        <div
          :key="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-usreou`"
          class="usreou"
          :data-qa="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-usreou`"
          style="max-width: 100%; overflow-wrap: anywhere;">
          {{ loading ? '-' : item.usreou || item.organizationView.usreou }}
        </div>
      </KeyValue>
      <KeyValue
        :caption="$t('Common.Name')"
        class="width-35 pr-3">
        <div
          :key="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-organization-title`"
          class="organization-title pointer"
          :data-qa="`setting-card-${loading ? 'loading' : item.settingOrganizationId}-organization-title`"
          style="max-width: 100%; overflow-wrap: anywhere;"
          @click="$emit('filterOrg', item.organizationView)">
          {{ loading ? '-' : (item.organizationTitle || item.organizationView.organizationTitle) }}
        </div>
      </KeyValue>
      <KeyValue
        :caption="$t('Common.SettingValue')"
        class="width-50 pr-3">
        <slot name="value"/>
      </KeyValue>
      <div class="pa-0 pr-3 flex flex-right flex-align-bottom width-10">
        <sTooltip
          :border="false"
          content="Користувачів з персональним налаштуванням"
          :open-delay="300"
          placement="bottom"
          popper-class="info-tooltip"
          type="white">
          <IconCount
            class="mt-auto mr-0"
            :count="item.userCount"
            icon="person"
            :icon-color="!item.userCount ? 'grey': ''"
            :text-class="{ 'grey--text': !item.userCount }"/>
        </sTooltip>
      </div>
    </div>
    <div
      v-show="showDetile"
      class="flex">
      <div
        class="flex flex-wrap">
        <sDivider class="my-3 width-100"/>
        <KeyValue
          :caption="$t('Common.Created')"
          class="width-50">
          <div>
            {{ item.createUserName }}
            <template v-if="item.createDate">
              {{ $d(new Date(item.createDate), "shortDate") }}, {{ $d(new Date(item.createDate), "time") }}
            </template>
          </div>
        </KeyValue>
        <KeyValue
          v-if="item.modifiedUserName || item.modifiedDate"
          :caption="$t('Application.Changed')"
          class="width-50">
          <div>
            {{ item.modifiedUserName }}
            <template v-if="item.modifiedDate">
              {{ $d(new Date(item.modifiedDate), "shortDate") }}, {{ $d(new Date(item.modifiedDate), "time") }}
            </template>
          </div>
        </KeyValue>
      </div>
    </div>
  </div>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'
import IconCount from 'components/common/elements/IconCount.vue'

export default {
  name: 'organizerSettingCard',
  data() {
    return {
      showDetile: false,
      loadDetile: true,
      settingParams: {}
    }
  },
  methods: {
  },
  computed: {
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    KeyValue,
    IconCount
  },
}
</script>
<style scoped lang="scss">
.organizer-setting-card {
  &.loading {
    .first-row,
    .second-row,
    .organization-title,
    .setting-value,
    .usreou{
      color: transparent;
      background: #cad3d2;
      border-radius: 4px;
    }
  }
  .organization-title,
  .setting-value,
  .usreou {
    text-align: start;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }
  &__caption {
    text-align: start;
    padding: 0 0 4px 0;
    color: var(--black-color);
    caret-color: var(--black-color);
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 0.01em;
    width: calc(100% - 35px);
    line-height: 1.25;
    .second-row {
      font-size: 13px;
    }
  }
}
</style>
